import {defineStore} from 'pinia'
import {nextTick} from "vue";
import {setCookie, getCookie} from "@js/helpers.ts";
import {useThemeStore} from "@js/store/ThemeStore.js";
import {checkDocument} from "@js/helpers.ts";

export const useSearchStore = defineStore('searchStore', {
    state: () => ({
        query: '',
        show: false,
        resultsLoaded: true,
        history: getCookie('history_search') ? JSON.parse(getCookie('history_search')) : [],
        results: [],
        getSearchTimeout: null,
        imageSearch: {
            previewUrl: null,
            file: null,
            InProgress: false,
            isOpen: false,
            animation_in_progress: false,
            imageSearchInProgress: false,
            results: [],
        },
        imageSearchResult: {
            isOpen: false,
            animation_in_progress: false,
        },
    }),

    getters: {
        filteredResults: (state) => {
            if (!state.query) return []
            return state.results.filter(r =>
                r.title.toLowerCase().includes(state.query.toLowerCase())
            )
        }
    },

    actions: {
        showImageSearchResult(){
            const themeStore = useThemeStore()
            themeStore.setBodyOverflow(true)
            this.imageSearchResult.animation_in_progress = false
            this.imageSearchResult.isOpen = true

            let vm = this
            setTimeout(function () {
                vm.imageSearchResult.animation_in_progress = true
            }, 50)
        },
        hideImageSearchResult(){
            const themeStore = useThemeStore()
            themeStore.setBodyOverflow(false)
            this.imageSearchResult.animation_in_progress = false

            let vm = this
            setTimeout(function () {
                vm.imageSearchResult.isOpen = false
                vm.imageSearchResult.animation_in_progress = true
            }, 500)
        },
        showImageSearch() {
            const themeStore = useThemeStore()
            themeStore.setBodyOverflow(true)
            this.imageSearch.animation_in_progress = false
            this.imageSearch.isOpen = true

            let vm = this
            setTimeout(function () {
                vm.imageSearch.animation_in_progress = true
            }, 50)
        },
        hideImageSearch() {
            const themeStore = useThemeStore()
            themeStore.setBodyOverflow(false)
            this.imageSearch.animation_in_progress = false

            let vm = this
            setTimeout(function () {
                vm.imageSearch.isOpen = false
                vm.imageSearch.animation_in_progress = true
            }, 500)
        },
        showDropdown() {
            this.show = true
            nextTick()
        },
        clearQuery() {
            this.query = ''
            this.results = []
        },
        repeatHistory(value) {
            this.query = value
            this.initSearch()
        },
        addToHistoryCache() {
            if (this.query === null || this.query === '') return;

            const key = 'history_search'
            let history = []

            try {
                const raw = getCookie(key)
                if (raw) {
                    history = JSON.parse(raw)
                }
            } catch (e) {
                history = []
            }

            // Удаляем дубликаты, добавляем в начало
            history = history.filter(item => item !== this.query)
            history.unshift(this.query)

            // Обрезаем до 3-х
            history = history.slice(0, 3)

            setCookie(key, JSON.stringify(history), 43200) // На месяц
            this.history = history
        },
        removeFromHistory(value) {
            const key = 'history_search'
            this.history = this.history.filter(item => item !== value)
            setCookie(key, JSON.stringify(this.history), 43200) //На месяц
        },
        initSearch() {
            this.addToHistoryCache()
        },
        getSearchData() {
            clearTimeout(this.getSearchTimeout);
            this.getSearchTimeout = setTimeout(() => {
                this.results = []
                if (this.query === null || this.query === '') {
                    return
                }
                this.addToHistoryCache()

                if (checkDocument) {
                    window.scrollTo({top: 0, behavior: 'smooth'}) // Скролл наверх
                }

                this.resultsLoaded = false
                axios.post('/axios/search/search-product-by-text', {
                    query: this.query,
                }).then(response => {
                    this.results = response.data
                    this.resultsLoaded = true
                }).catch(error => {
                    this.resultsLoaded = true
                })
            }, 500);
        },
        searchByImage(file) {
            if (!file) {
                console.warn('No file passed to searchByImage')
                return
            }

            this.imageSearch.imageSearchInProgress = true
            this.imageSearch.results = []
            this.resultsLoaded = false

            const form = new FormData()
            form.append('photo', file)

            axios.post('/axios/search/search-by-image', form, {
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(({data}) => {
                this.imageSearch.results = data
                this.imageSearch.imageSearchInProgress = false
                this.resultsLoaded = true

                if (this.imageSearch.results.length) {
                    this.hideImageSearch()
                    this.showImageSearchResult()
                }
            }).catch(error => {
                console.error('Image search error:', error)
                this.imageSearch.imageSearchInProgress = false
                this.resultsLoaded = false
            })
        }
    }
})
